<template>
  <div class="relative flex flex-col min-w-0 break-words w-full h-full mb-4 shadow-lg rounded-lg bg-white">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            TOTAL NUMBER OF PATIENTS
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Overview of Patients
          </h2>
        </div>
        <div class="relative w-full max-w-full flex-grow flex-1 text-right">
          <router-link to="/dahla_elog_subject" v-slot="{ href , navigate }">
          <button :href="href" @click="navigate" class="accordion-header cursor-pointer text-sm bg-blueGray-600 shadow-md
            text-white active:bg-blueGray-100 px-3 py-1 rounded outline-none focus:outline-none mr-1 
              mb-1 ease-linear transition-all duration-150" type="button">
              View Subject</button>
            </router-link>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto ">
      <div class="flex flex-wrap ">
        <div class="w-full md:w-6/12 px-4 text-center">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-8 shadow-md rounded-lg" style="background-color: #E0C3FC;"
          ref="accept" @mouseover="zoomIn('accept')" @mouseleave="zoomOut('accept')" @click="toggleAccordion(1)">
            <div class="px-4 py-5 flex-auto">
              <div
                class="text-2xl p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-5 shadow-lg rounded-full bg-white"
                style="color: #9599E2;">
                <i class="fas fa-users"></i>
              </div>
              <h6 class="text-xl font-semibold">Management of Patients (Accepted)</h6>
              <p class="text-5xl mt-2 mb-4 font-semibold">
                {{elog_arr.sum_patient_accept}}
              </p>
            </div>
          </div>
        </div>
        <div class="w-full md:w-6/12 px-4 text-center">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-8 shadow-md rounded-lg" style="background-color: #A9C9FF;"
          ref="pending" @mouseover="zoomIn('pending')" @mouseleave="zoomOut('pending')" @click="toggleAccordion(2)">
            <div class="px-4 py-5 flex-auto">
              <div
                class="text-2xl p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-5 shadow-lg rounded-full bg-white"
                style="color: #52ACFF;">
                <i class="fas fa-users"></i>
              </div>
              <h6 class="text-xl font-semibold">Management of Patients (Pending)</h6>
              <p class="text-5xl mt-2 mb-4 font-semibold">
                {{elog_arr.sum_patient_pending}}
              </p>
            </div>
          </div>
        </div>    
      </div>
      <div v-if="showAccordion[1]" class="accordion-content flex-auto w-full h-350-px overflow-x-auto text-center text-sm rounded-lg shadow">
        <table class="table-auto w-full bg-transparent border-collapse">
          <thead class="sticky top-0">
            <tr>
              <th
                class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold text-black" style="background-color: #E0C3FC;">
                No.
              </th>
              <th
                class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold text-black" style="background-color: #E0C3FC;">
                List of Disease Groups
              </th>
              <th
                class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold text-black" style="background-color: #E0C3FC;">
                Use (Cases)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(elog_accept, index) in elog_accept_arr" :key="index">
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ elog_accept.num }}
              </td>
              <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                {{ elog_accept.disease_group_name }}
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ elog_accept.sum_case }}              
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="showAccordion[2]" class="accordion-content flex-auto w-full h-350-px overflow-x-auto text-center text-sm rounded-lg shadow">
        <table class="table-auto w-full bg-transparent border-collapse">
          <thead class="sticky top-0">
            <tr>
              <th
                class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold text-black" style="background-color: #A9C9FF;">
                No.
              </th>
              <th
                class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold text-black" style="background-color: #A9C9FF;">
                List of Disease Groups
              </th>
              <th
                class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold text-black" style="background-color: #A9C9FF;">
                Use (Cases)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(elog_pending, index) in elog_pending_arr" :key="index">
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ elog_pending.num }}
              </td>
              <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                {{ elog_pending.disease_group_name }}
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ elog_pending.sum_case }}              
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from './../../services/student_services';

export default {
  data() {
    return {
      elog_accept_arr: [],
      elog_pending_arr: [],
      elog_arr: [],
      showAccordion: {
        1: true,
        2: false
      }
    }
  },
  methods: {
    zoomIn(refName) {
      const cardElement = this.$refs[refName];
      cardElement.style.transform = 'scale(1.05)';
    },
    zoomOut(refName) {
      const cardElement = this.$refs[refName];
      cardElement.style.transform = "scale(1)";
    },
    toggleAccordion(key) {
      if(key==1){
        this.showAccordion[1] = true;
        this.showAccordion[2] = false;
      }else{
        this.showAccordion[1] = false;
        this.showAccordion[2] = true;
      }
    },
    async elog() {
      api.elog().then(async (result) => {        
        this.elog_arr = result.data;
      });
    },
    async elog_patient_accept() {
      api.elog_patient_accept().then(async (result) => {        
        this.elog_accept_arr = result.data;
      });
    },
    async elog_patient_pending() {
      api.elog_patient_pending().then(async (result) => {        
        this.elog_pending_arr = result.data;
      });
    },

  }, created: async function () {
      await this.elog_patient_accept(),
      await this.elog_patient_pending(),
      await this.elog()
  },
};
</script>